import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Save } from "lucide-react";

export default function SeoManager() {
  const [pages, setPages] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.get("/cms/pages").then(({ data }) => { setPages(data); if (data[0]) setActive(data[0]); }); }, []);

  const save = async () => {
    await api.put(`/cms/pages/${active.id}`, {
      title: active.title, slug: active.slug, blocks: active.blocks,
      seo: active.seo || {}, is_home: !!active.is_home, published: !!active.published,
    });
    setPages(pages.map((p) => p.id === active.id ? active : p));
  };

  if (!active) return <div className="p-8">Keine Seiten vorhanden.</div>;
  const seo = active.seo || {};
  const setSeo = (patch) => setActive({ ...active, seo: { ...seo, ...patch } });

  return (
    <div className="p-8 lg:p-12 mv-fade-in max-w-5xl">
      <div className="mb-8">
        <p className="mv-label mb-2">Suchmaschinen-Optimierung</p>
        <h1 className="font-display text-4xl">SEO Manager</h1>
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1">
          <p className="mv-label mb-3">Seiten</p>
          <div className="space-y-1">
            {pages.map((p) => (
              <button key={p.id} onClick={() => setActive(p)} className={`w-full text-left px-3 py-2.5 rounded-lg text-sm transition-colors ${active.id === p.id ? "bg-[var(--mv-primary)] text-white" : "hover:bg-[var(--mv-surface)]"}`} data-testid={`seo-page-${p.slug}`}>
                {p.title}
                <span className={`block text-xs ${active.id === p.id ? "text-white/80" : "text-[var(--mv-text-muted)]"}`}>/{p.slug}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="mv-card p-6 mb-5">
            <p className="mv-label mb-4">Meta</p>
            <label className="block text-xs mb-1">SEO-Titel</label>
            <input data-testid="seo-title-input" className="mv-input mb-3" value={seo.title || ""} onChange={(e) => setSeo({ title: e.target.value })} />
            <label className="block text-xs mb-1">Meta-Beschreibung</label>
            <textarea className="mv-input min-h-[80px] mb-3" value={seo.description || ""} onChange={(e) => setSeo({ description: e.target.value })} />
            <label className="block text-xs mb-1">URL Slug</label>
            <input className="mv-input mb-3" value={active.slug} onChange={(e) => setActive({ ...active, slug: e.target.value })} />
            <label className="block text-xs mb-1">Open Graph Bild URL</label>
            <input className="mv-input" value={seo.og_image || ""} onChange={(e) => setSeo({ og_image: e.target.value })} />
            <button data-testid="save-seo-btn" onClick={save} className="mv-btn mt-5"><Save className="w-4 h-4" /> Speichern</button>
          </div>

          <div className="mv-card p-5">
            <p className="mv-label mb-3">Vorschau (Google)</p>
            <p className="text-xs" style={{ color: "var(--mv-secondary)" }}>https://salon.studiomv.de/{active.slug}</p>
            <p className="text-lg" style={{ color: "#1a0dab" }}>{seo.title || active.title}</p>
            <p className="text-sm" style={{ color: "var(--mv-text-muted)" }}>{seo.description || "Keine Meta-Beschreibung gesetzt."}</p>
          </div>

          {seo.og_image && (
            <div className="mv-card p-5 mt-5">
              <p className="mv-label mb-3">Social-Vorschau</p>
              <img src={seo.og_image} className="w-full max-h-64 object-cover rounded-lg border" style={{ borderColor: "var(--mv-border)" }} />
              <p className="font-medium mt-2">{seo.title || active.title}</p>
              <p className="text-sm" style={{ color: "var(--mv-text-muted)" }}>{seo.description}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
